import * as StaticContentActions from '../actions/static-content'
import { StaticContent } from '../models'
import { PaginatedList } from '../libs/infinite-paginator'

export interface State {
  staticContentsById: { [key: number]: StaticContent }
  staticContentsByVideo: { [key: number]: StaticContent[] }
  staticContentList: PaginatedList<StaticContent>
  staticContent: StaticContent
}

const initialState: State = {
  staticContentsById: {},
  staticContentsByVideo: {},
  staticContentList: null,
  staticContent: null
}

export function reducer(state: State = initialState, action: StaticContentActions.All): State {
  switch (action.type) {
    case StaticContentActions.SET_VIDEO_STATIC_CONTENTS: {
      state.staticContentsByVideo[action.videoId] = action.staticContents
      for (const staticContent of action.staticContents) {
        state.staticContentsById[staticContent.id] = staticContent
      }
      return { ...state, staticContentsById: { ...state.staticContentsById }, staticContentsByVideo: { ...state.staticContentsByVideo } }
    }
    case StaticContentActions.SET_STATIC_CONTENT_LIST: {
      return { ...state, staticContentList: action.statcContentList }
    }
    case StaticContentActions.SELECT_STATIC_CONTENT: {
      const staticContentsById = { ...state.staticContentsById }
      staticContentsById[action.staticContent.id] = action.staticContent

      return { ...state, staticContentsById, staticContent:action.staticContent }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/static-content.ts